<template>
  <fragment>
    <default-header :h2="'Privacy policy'"></default-header>
    <back-btn></back-btn>
    <div class="innerContent justifyContentFlexStart">
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci aut eius id iusto obcaecati quas rem saepe? Ad assumenda, dolore, ea maiores pariatur repellendus sit tenetur ullam veritatis vero voluptatum!</p>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa magnam recusandae sunt. Assumenda consequuntur dolor doloremque eligendi explicabo fugiat, inventore modi odit ratione soluta! Aut consectetur dolores nesciunt optio tempore?</p>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur dolorum facere iste laudantium maxime quam repellendus. Consectetur dolor, esse facilis, in ipsam ipsum iste nesciunt numquam quia quidem reiciendis voluptas.</p>
    </div>
  </fragment>
</template>

<script>
import DefaultHeader from "@/partials/DefaultHeader";
import BottomNavigation from "@/partials/BottomNavigation";
import BackBtn from '../components/BackBtn';

export default {
  name: "Privacy Policy",
  components: {
    DefaultHeader,
    BottomNavigation,
    BackBtn

  }
};
</script>
